import { ui } from "@/lib/ui";

export const FormField = ({ id, label, children }) => (
  <div className="space-y-1.5">
    <label htmlFor={id} className={`block ${ui.label}`}>{label}</label>
    {children}
  </div>
);

export const FormSection = ({ step, title, children }) => (
  <section className="space-y-4">
    <div className="flex items-center gap-3">
      <span className="font-mono text-xs font-bold text-[#FF007F]">[{step}]</span>
      <h3 className="font-display text-sm uppercase tracking-[0.2em] text-slate-100">{title}</h3>
      <span className="flex-1 h-px bg-gradient-to-r from-cyan-500/40 to-transparent" />
    </div>
    {children}
  </section>
);

export const Panel = ({ children, className = "", ...rest }) => (
  <div className={`bg-[#0A0F1C]/90 border border-slate-800 backdrop-blur-md relative hud-corner ${className}`} {...rest}>
    {children}
  </div>
);

export const SectionLabel = ({ children }) => (
  <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#00FF66]">// {children}</p>
);
